module.exports = __webpack_public_path__ + "img/x.5c3936d4.svg";